var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{attrs:{"hide-details":""},scopedSlots:_vm._u([{key:"label",fn:function(){return [_vm._v(" What about "),_c('strong',[_vm._v("icon")]),_vm._v(" here? "),_c('v-icon',{staticStyle:{"vertical-align":"middle"}},[_vm._v(" "+_vm._s(_vm.icons.mdiFileFindOutline)+" ")])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }